const RECENTLY_VIEWED_KEY = 'track50:recently-viewed';

function saveRecentlyViewed(handle, id) {
  if (!handle) return;
  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
  } catch (e) {
    items = [];
  }
  items = items.filter((item) => item.handle !== handle);
  items.unshift({ handle, id: String(id || '') });
  items = items.slice(0, 12);
  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
}

function buildProductCardHtml(product) {
  if (typeof window.buildThemeProductCard === 'function') {
    return window.buildThemeProductCard(product, { floatingAdd: false });
  }
  return '';
}

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    const url = this.dataset.url;
    if (!url) return;

    const load = () => {
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const source = doc.querySelector('product-recommendations');
          const body = this.querySelector('[data-product-rows-body]');
          if (!source || !body) return;
          const grid = source.querySelector('.product-rows__grid, .product-rows__placeholder');
          if (grid && grid.innerHTML.trim()) {
            body.innerHTML = grid.outerHTML;
            this.dataset.loaded = 'true';
          } else {
            this.hidden = true;
          }
        })
        .catch(() => {
          this.hidden = true;
        });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        },
        { rootMargin: '200px' }
      );
      observer.observe(this);
    } else {
      load();
    }
  }
}

function applyProductRowsGridClasses(grid, section) {
  if (!grid || !section) return;
  const columns = section.dataset.columns || '4';
  const columnsMobile = section.dataset.columnsMobile || '2';
  grid.classList.add('grid', `grid--${columns}`, `grid--mobile-${columnsMobile}`);
}

async function initRecentlyViewed() {
  const section = document.querySelector('[data-recently-viewed-section]');
  if (!section) return;

  const currentHandle = section.dataset.currentHandle;
  const currentId = section.dataset.currentId;
  if (currentHandle) saveRecentlyViewed(currentHandle, currentId);

  const limit = parseInt(section.dataset.limit, 10) || 4;
  const grid = section.querySelector('[data-recently-viewed-items]');
  applyProductRowsGridClasses(grid, section);
  const wrapper = section.querySelector('[data-recently-viewed-grid]');
  const placeholder = section.querySelector('[data-recently-viewed-placeholder]');
  if (!grid) return;

  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
  } catch (e) {
    items = [];
  }

  items = items.filter((item) => item.handle && item.handle !== currentHandle).slice(0, limit);
  if (!items.length) {
    if (placeholder) return;
    section.hidden = true;
    return;
  }

  const cards = await Promise.all(
    items.map(async (item) => {
      try {
        const res = await fetch(`/products/${item.handle}.js`);
        if (!res.ok) return '';
        const product = await res.json();
        return buildProductCardHtml(product);
      } catch (e) {
        return '';
      }
    })
  );

  const html = cards.filter(Boolean).join('');
  if (!html) {
    section.hidden = true;
    return;
  }

  grid.innerHTML = html;
  if (wrapper) wrapper.hidden = false;
  if (placeholder) placeholder.hidden = true;
}

customElements.define('product-recommendations', ProductRecommendations);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
} else {
  initRecentlyViewed();
}
